import { render } from "./LoadingState.vue?vue&type=template&id=637249cb&scoped=true"
const script = {}

import "./LoadingState.vue?vue&type=style&index=0&id=637249cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637249cb"]])

export default __exports__